/*
* 1.使用this.$confirm(optoion) 的方式调用
* 2.传参和默认值：optoion={}
*   width: 模态框的宽度，默认为'260px',//传入字符串样式-> '260px'
*   showCancelBtn: 布尔值，默认为true， 是否显示关闭按钮
*   cancel:用户点击关闭按钮调用的函数
*   confirm：用户点击确认按钮触发的函数
*   content：显示的文本内容
*
 */
import Confirm from './confirm';
let plugin = {};
//删除dom元素
let removeDom = event => {
  event.target.parentNode.removeChild(event.target);
};
plugin.install = function (Vue) {
  // 声明弹窗构造器继承Confirm的构造器
  const ConfirmConstructor = Vue.extend(Confirm);
  // 在原型上实现close方法
  ConfirmConstructor.prototype.closeConfirm = function () {
    this.visible = false;
    this.$el.addEventListener('transitionend', removeDom);
  };
  // 在原型上扩展确认方法
  ConfirmConstructor.prototype.submitConfirm = function () {
    let _this = this;
      _this.visible = false;
      _this.$el.addEventListener('transitionend', removeDom);
      _this.confirmFn && _this.confirmFn();
  };
  Vue.prototype.$confirm = function (option = {}){
      // 将confirm实例挂载到dom上
      let instance = new ConfirmConstructor().$mount(document.createElement('div'));
      // 初始化参数 instance 是子组件 option 是调用时用户的操作
      instance.visiable = true;// 是否展示
      instance.width = option.width || instance.width;//设置宽度
      instance.title = option.title || instance.title;//标题
      instance.cancelText = option.cancelText || instance.cancelText;//取消文本内容
      instance.sureText = option.sureText || instance.sureText;//确认文本内容
      instance.content = option.content || option ||instance.content;//正文内容
      instance.showCancelBtn = option.showCancelBtn !== undefined ? option.showCancelBtn : true;// 是否展示取消按钮
      instance.closeVisible = option.closeVisible !== undefined ? option.closeVisible : true;// 是否展示关闭图标
      instance.confirmFn = option.confirm ||  null;
      //把元素添加到页面
      document.body.appendChild(instance.$el);
        let pro = new Promise(function (resolve,reject) {
          document.getElementById('confirm').addEventListener('click',function () {
            resolve(this);
            reject(this)
          });
        });
        return pro;
  }
};
export default plugin



// WEBPACK FOOTER //
// ./src/components/confirmjs.js